
import { add, tryFind, map as map_1, ofList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { singleton, ofArray, tryFind as tryFind_1, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { CreateRoleDto_$reflection, CreateRoleDto, UpdateRoleDto_$reflection, UpdateRoleDto, RoleDefinition_$reflection, PermissionModule_all, Permission__get_Ladder, PermissionGrantModule_denied } from "../../../Shared/Roles.js";
import { equals, compare } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { orElse, bind, map as map_2, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Msg, State, RoleForm } from "./Types.js";
import { concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_none, Cmd_batch, Cmd_ofEffect } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { RoleId__get_unwrap as RoleId__get_unwrap_1, FormState__setValidationResponse_5219762A, FormState__startLoading, RoleId_$reflection, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../../Communication.js";
import { Storage_$reflection } from "../../../Shared/Storage.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { RoleId__get_unwrap } from "../../../Shared/Shared.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";

const deniedPermissions = ofList(map((permission) => [permission, PermissionGrantModule_denied(Permission__get_Ladder(permission))], PermissionModule_all), {
    Compare: (x, y) => (compare(x, y) | 0),
});

function withAllPermissions(permissions) {
    return map_1((permission, denied) => defaultArg(tryFind(permission, permissions), denied), deniedPermissions);
}

const emptyForm = new RoleForm("", "", undefined, false, deniedPermissions);

function displayName(systemRoleNames, role) {
    return defaultArg(map_2((tuple) => tuple[1], bind((systemRole) => tryFind_1((tupledArg) => equals(tupledArg[0], systemRole), systemRoleNames), role.SystemKey)), role.Name);
}

function formOf(state, roles) {
    const find = (roleId) => tryFind_1((role) => equals(role.Id, roleId), roles);
    const matchValue = state.Kind;
    switch (matchValue.tag) {
        case 1:
            return map_2((role_1) => (new RoleForm(concat(displayName(state.SystemRoleNames, role_1), " ", ...state.CopySuffix), "", orElse(role_1.SystemKey, role_1.SourceSystemKey), false, withAllPermissions(role_1.Permissions))), find(matchValue.fields[0]));
        case 2:
            return map_2((role_2) => (new RoleForm(displayName(state.SystemRoleNames, role_2), role_2.Name, role_2.SourceSystemKey, role_2.SystemKey != null, withAllPermissions(role_2.Permissions))), find(matchValue.fields[0]));
        default:
            return emptyForm;
    }
}

const navigateToOverview = Cmd_ofEffect((_arg) => {
    RouterModule_nav(ofArray(["settings", "roles"]), 1, 1);
});

export function init(kind, copySuffix, systemRoleNames) {
    return [new State(kind, copySuffix, systemRoleNames, new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty()), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(RoleDefinition_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/roles", (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(6, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
        const pr_1 = response_2.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item_2) => (new Msg(4, [Item_2])), (Item_3) => (new Msg(6, [Item_3])))]))];
}

function updateForm(state, change) {
    const matchValue = state.Form;
    if (matchValue.tag === 0) {
        return state;
    }
    else {
        return new State(state.Kind, state.CopySuffix, state.SystemRoleNames, new RequestedValue$1(1, [change(matchValue.fields[0])]), state.Storages, state.FormState);
    }
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [updateForm(state, (form_1) => (new RoleForm(form_1.Name, form_1.StoredName, form_1.SourceSystemRole, form_1.IsSystemRole, add(msg.fields[0], msg.fields[1], form_1.Permissions)))), Cmd_none()];
        case 2: {
            const matchValue = state.Form;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const form_2 = matchValue.fields[0];
                let cmd;
                const matchValue_1 = state.Kind;
                switch (matchValue_1.tag) {
                    case 2: {
                        const dto_2 = new UpdateRoleDto(form_2.IsSystemRole ? form_2.StoredName : form_2.Name, form_2.Permissions);
                        const body_3 = toString(0, Auto_generateBoxedEncoder_437914C6(UpdateRoleDto_$reflection(), undefined, undefined, undefined)(dto_2));
                        cmd = Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                            let url_5;
                            return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_2) => {
                                const pr_1 = response_2.arrayBuffer();
                                return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), RoleId_$reflection()));
                            }, refreshOn_1)))(true);
                        })), [concat("/api/roles/", ...RoleId__get_unwrap(matchValue_1.fields[0])), body_3], (Item_2) => (new Msg(5, [Item_2])), (Item_3) => (new Msg(6, [Item_3])));
                        break;
                    }
                    default: {
                        const dto = new CreateRoleDto(form_2.Name, form_2.SourceSystemRole, form_2.Permissions);
                        cmd = Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                            let url_2;
                            return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                                const pr = response.arrayBuffer();
                                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), RoleId_$reflection()));
                            }, refreshOn)))(true);
                        })), ["/api/roles", toString(0, Auto_generateBoxedEncoder_437914C6(CreateRoleDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(6, [Item_1])));
                    }
                }
                return [new State(state.Kind, state.CopySuffix, state.SystemRoleNames, state.Form, state.Storages, FormState__startLoading(state.FormState)), cmd];
            }
        }
        case 3: {
            const matchValue_2 = formOf(state, msg.fields[0]);
            if (matchValue_2 == null) {
                return [state, navigateToOverview];
            }
            else {
                return [new State(state.Kind, state.CopySuffix, state.SystemRoleNames, new RequestedValue$1(1, [matchValue_2]), state.Storages, state.FormState), Cmd_none()];
            }
        }
        case 4:
            return [new State(state.Kind, state.CopySuffix, state.SystemRoleNames, state.Form, new RequestedValue$1(1, [msg.fields[0]]), state.FormState), Cmd_none()];
        case 5:
            if (msg.fields[0].tag === 1) {
                return [new State(state.Kind, state.CopySuffix, state.SystemRoleNames, state.Form, state.Storages, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Kind, state.CopySuffix, state.SystemRoleNames, state.Form, state.Storages, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("settings.roles.saved"), Cmd_ofEffect((_arg) => {
                    RouterModule_nav(ofArray(["settings", "roles", RoleId__get_unwrap_1(msg.fields[0].fields[0])]), 1, 1);
                })]))];
            }
        case 6:
            return [new State(state.Kind, state.CopySuffix, state.SystemRoleNames, state.Form, state.Storages, FormState_get_empty()), Cmd_errorToast("general.a_error_occured")];
        default:
            return [updateForm(state, (form) => (new RoleForm(msg.fields[0], form.StoredName, form.SourceSystemRole, form.IsSystemRole, form.Permissions))), Cmd_none()];
    }
}

